import axios from 'axios'

class SalaEsperaApiClient {

    async adicionarPaciente(pacienteId) {
        return axios.post(`/salaEspera/inserir/${pacienteId}`)
    }

    async buscarDados() {
        return axios.get('/salaEspera')
    }

    async removerSalaEspera(salaEsperaId) {
        return axios.delete(`/salaEspera/removerSalaEspera/${salaEsperaId}`)
    }

}

export default new SalaEsperaApiClient()
